import { create } from 'zustand';

export const useMapDrawStore = create(set => ({
  mapDraw: null,
  activeMode: 'select',
  setMapDraw: mapDraw => set({ mapDraw }),
  setActiveMode: activeMode => set({ activeMode }),
}));
